import OhsApiRequest from 'global-services/api/OhsApiRequest';
import { OhsApiRequestName, RequestType } from 'global-services/api/OhsApiModels';
import { OhsHrLookup } from 'human-resource/models/OhsHumanResourceModels';
import { ModuleType } from 'global-services/constants/OhsObject';
import { OhsHRContractorLinkItem } from 'global-components/form/fields/linkHrContractor/OhsHrContractorLinkModels';
import OhsContractorLookup from 'contractor/models/OhsContractorLookUp';

import { LinkItemFormat } from './OhsLinkModels';

// eslint-disable-next-line import/prefer-default-export
export const returnUniqueLink = (link: OhsHrLookup | OhsContractorLookup) => {
  switch (link.type) {
    case ModuleType.HR:
      return `${link?._id}-${link?.businessName || ''}-${link?.email || ''}`;
    case ModuleType.Contractor:
      return `${link?._id}-${link?.businessName || ''}-${link?.contactEmail || ''}`;
    default:
      return '';
  }
};

export const returnUniqueCustomLink = (link: LinkItemFormat) => {
  return `${link?._id}-${link?.name || ''}-${link?.description || ''}-${link?.description2 || ''}`;
};

export const getHRLinksByIds = async (_ids: string[]): Promise<OhsHRContractorLinkItem[]> => {
  const res: any = await OhsApiRequest(
    RequestType.Module,
    ModuleType.HR,
    OhsApiRequestName.Enhance,
    { _ids }
  );
  return res;
};
